exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-glyphicon {\r\n    padding:8px;\r\n    background:#ffffff;\r\n    margin-right:4px;\r\n}\r\n.icon-btn {\r\n    padding: 1px 15px 3px 2px;\r\n    border-radius:50px;\r\n}\r\n\r\ntable .td-actions{\r\n    padding-top: 14px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/relatorios/gerenciar-conexoes/gerenciar-conexoes.component.css
// module id = ../../../../../src/app/paginas/relatorios/gerenciar-conexoes/gerenciar-conexoes.component.css
// module chunks = 1